import { I18n } from 'lib/i18n'
import React from 'react'
import { Card, Icon, List, Popup } from 'semantic-ui-react'
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
  const { nps = {} } = state.carts
  return { nps }
}

class NPSScore extends React.PureComponent {
  render() {
    const { nps } = this.props
    let rating
    if (nps.score > 50) rating = 'excellent'
    else if (nps.score > 0) rating = 'good'
    else if (nps.score <= 0) rating = 'negative'
    const icon = nps.score > 0 ? 'thumbs up outline' : 'thumbs down outline'
    return (
      <Popup
        keepInViewPort
        wide
        position="right center"
        header="Detail scores"
        trigger={
          <Card fluid className={`nps ${rating}`}>
            <Icon name={icon} />
            <Card.Content>
              <Card.Header>
                <div
                  className="ellipsis"
                  children={I18n.t(`admin.dashboard.nps`, { score: nps.score })}
                />
              </Card.Header>
            </Card.Content>
          </Card>
        }
        inverted>
        <List
          children={(nps.distribution || []).map((count, index) => (
            <List.Item>
              {index + 1}: {count} Votes
            </List.Item>
          ))}
        />
      </Popup>
    )
  }
}

NPSScore = connect(mapStateToProps)(NPSScore)
export default NPSScore



// WEBPACK FOOTER //
// ./src/components/admin/Helper/NPSScore.jsx